import { IconButton, InputAdornment, Typography } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import Iconify from "minimals-template/components/Iconify"
import { legislationHref } from "routes/schedule/lib/legislation-href.mjs"
import { isValidLegislationUrl } from "../server/lib/legislation-library-validation.mjs"

export function LegislationLibraryUrlField({
    label = "URL",
    sideEffects = false,
    "data-cy": dataCy = "legislation-url-input",
}) {
    const { target } = useBoundContext()
    const [url] = useBoundValue("url")
    const hasError = !!url?.trim() && !isValidLegislationUrl(url)

    return (
        <BoundTextField
            field="url"
            label={label}
            sideEffects={sideEffects}
            error={hasError}
            transformOutOnBlur={stripScheme}
            helperText={hasError ? "Enter a valid URL (e.g. example.com/page)" : undefined}
            data-cy={dataCy}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Typography variant="body2" sx={{ color: "text.disabled" }}>
                            https://
                        </Typography>
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="Open legislation in new tab"
                            size="small"
                            edge="end"
                            onClick={handleOpen}
                        >
                            <Iconify icon="mdi:open-in-new" sx={{ width: 18, height: 18 }} />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    )

    function handleOpen() {
        const url = target?.url
        if (!url) return
        window.open(legislationHref(url), "_blank", "noopener,noreferrer")
    }
}

// Applied on blur, not per keystroke: rewriting the text mid-edit fights a paste and drops keystrokes on a busy page.
export function stripScheme(value) {
    return (value ?? "").replace(/^https?:\/\//i, "")
}
